/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Previous_MarkerInputs */

const en_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Marker`)
};

const fr_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqueur precedent`)
};

const de_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriger Marker`)
};

const it_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcatore precedente`)
};

const ru_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий маркер`)
};

const es_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcador anterior`)
};

const zh_cn2_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一个标记`)
};

const ja_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のマーカー`)
};

const hi_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला मार्कर`)
};

const pt_pt2_shortcut_keys_name_previous_marker = /** @type {(inputs: Shortcut_Keys_Name_Previous_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcador anterior`)
};

/**
* | output |
* | --- |
* | "Previous Marker" |
*
* @param {Shortcut_Keys_Name_Previous_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_previous_marker = /** @type {((inputs?: Shortcut_Keys_Name_Previous_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Previous_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_previous_marker(inputs)
	if (locale === "de") return de_shortcut_keys_name_previous_marker(inputs)
	if (locale === "it") return it_shortcut_keys_name_previous_marker(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_previous_marker(inputs)
	if (locale === "es") return es_shortcut_keys_name_previous_marker(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_previous_marker(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_previous_marker(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_previous_marker(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_previous_marker(inputs)
	return en_shortcut_keys_name_previous_marker(inputs)
});